export const SET_VISIBILITY = 'SET_VISIBILITY';
export const SET_ACTIVE_MODULE = 'SET_ACTIVE_MODULE';